"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_jss_1 = require("react-jss");
var Typography_1 = require("../Typography");
var styles_1 = __importDefault(require("./styles"));
var classnames_1 = __importDefault(require("classnames"));
var Checkmark_1 = __importDefault(require("./Checkmark"));
var useStyles = (0, react_jss_1.createUseStyles)(styles_1.default);
// eslint-disable-next-line no-redeclare
var Checkbox = function (_a) {
    var checked = _a.checked, className = _a.className, disabled = _a.disabled, defaultChecked = _a.defaultChecked, helpText = _a.helpText, label = _a.label, onChange = _a.onChange, name = _a.name, value = _a.value, indeterminate = _a.indeterminate, error = _a.error, inputAttributes = __rest(_a, ["checked", "className", "disabled", "defaultChecked", "helpText", "label", "onChange", "name", "value", "indeterminate", "error"]);
    var classes = useStyles();
    var classname = (0, classnames_1.default)(classes.root, className, disabled && classes.disabled);
    var inputRef = (0, react_1.useRef)(null);
    var _b = (0, react_1.useState)(defaultChecked !== null && defaultChecked !== void 0 ? defaultChecked : false), uncontrolledAriaChecked = _b[0], setUncontrolledAriaChecked = _b[1];
    var handleChange = function (event) {
        setUncontrolledAriaChecked(event.target.checked);
        onChange && onChange(event);
    };
    var getAriaCheckedState = function () {
        if (indeterminate) {
            return 'mixed';
        }
        if (typeof checked === 'boolean') {
            return checked;
        }
        return uncontrolledAriaChecked;
    };
    (0, react_1.useEffect)(function () {
        if (inputRef.current) {
            // there's no HTML attribute for `indeterminate`, so need to set w/ JS
            inputRef.current.indeterminate = !!indeterminate;
        }
    }, [indeterminate]);
    return (react_1.default.createElement("label", { className: classname },
        react_1.default.createElement("div", { className: classes.inputWrapper },
            react_1.default.createElement("input", __assign({ ref: inputRef, type: "checkbox", className: (0, classnames_1.default)(classes.input, error && !disabled && classes.error), value: value, checked: checked, "aria-checked": getAriaCheckedState(), name: name, disabled: disabled, onChange: handleChange }, inputAttributes)),
            react_1.default.createElement(Checkmark_1.default, { indeterminate: indeterminate, className: classes.check })),
        react_1.default.createElement("span", null,
            react_1.default.createElement(Typography_1.UtilityText, { size: "medium", color: disabled ? 'disabled' : 'primary' }, label),
            helpText && (react_1.default.createElement(Typography_1.UtilityText, { size: "xsmall", color: "secondary" }, helpText)))));
};
exports.default = Checkbox;
